<template>
  <div class="details">
    <p>City of Kyiv</p>
    <img src="@/assets/image.png" alt="地図サンプル">
    <button @click="closepop">閉じる</button>
  </div>
</template>

<script>
export default {
  name: 'Hanrei',
  methods: {
    closepop() {
      this.$emit('closepop')
    }
  }
}
</script>

<style>
.details {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 350px;
  background-color: #fff;
  border:  5px solid #111;
}

.details img {
  width: 280px;
  height: 280px;
  margin: 10px;
}

</style>
